import { render, staticRenderFns } from "./areamap.vue?vue&type=template&id=0f0a2243&scoped=true&"
import script from "./areamap.vue?vue&type=script&lang=js&"
export * from "./areamap.vue?vue&type=script&lang=js&"
import style0 from "./areamap.vue?vue&type=style&index=0&id=0f0a2243&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0a2243",
  null
  
)

export default component.exports